import { Button } from "antd";
import PropTypes from "prop-types";
import approveIcon from "../../../app/assets/images/approve.png";
import declineIcon from "../../../app/assets/images/decline.png";

const SendMessageModal = ({ onCancel, onSaveSuccess, isSend, isLoading }) => {
  return (
    <div className="flex flex-col gap-3 align-middle items-center py-12">
      {isSend ? <img src={approveIcon} alt="Approve" className="text-4xl" /> : <img src={declineIcon} alt="Decline" className="text-4xl" />}
      <div className="text-center">
        <h2 className="font-semibold m-0 p-0">{isSend ? "Send Message?" : "Cancel Message?"}</h2>
      </div>
      <div className="flex flex-grow justify-end gap-6 mt-4">
        <Button
          size="large"
          className="w-40 !border-orange-500 !text-orange-500 !hover:text-orange-700 !hover:border-orange-700 hover:opacity-70 font-semibold rounded-lg"
          onClick={onCancel}
        >
          CANCEL
        </Button>
        <Button
          type="primary"
          size="large"
          loading={isLoading}
          className="w-40 border-none font-semibold rounded-lg hover:opacity-80"
          style={{ backgroundColor: "#F45F0C" }}
          onClick={onSaveSuccess}
        >
          {isSend ? "SEND" : "YES"}
        </Button>
      </div>
    </div>
  );
};

export default SendMessageModal;

SendMessageModal.propTypes = {
  onCancel: PropTypes.func.isRequired,
  onSaveSuccess: PropTypes.func.isRequired,
  isSend: PropTypes.bool,
  isLoading: PropTypes.bool,
};
